import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

@observer
class ReadAlsoBox extends Component {
    loadAll = async () => {
        const { articleId, stores } = this.props;
        const { articleStore } = stores;
        if (articleId) {
            await articleStore.loadFactboxArticle(articleId);
        }
    }

    openArticle = async (e) => {
        e.preventDefault();
        const { articleId, stores, onOpenArticle } = this.props;
        if (onOpenArticle) {
            onOpenArticle(articleId);
            return;
        }
        const { articleStore } = stores;
        articleStore.updateKeyValue('article', {});
        await articleStore.load(articleId, false, { addData: ['tags', 'likes', 'comments', 'polls'] });
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { articleId, stores } = this.props;
        const { articleStore } = stores;

        const factboxArticles = articleStore.factboxArticles || {};
        const article = factboxArticles[articleId];

        if (!article) {
            return null;
        }

        const thumbnail = article.images?.[0]?.s3SmallLink || article.images?.[0]?.s3MediumLink;

        return (
            <div
                class='my-4 p-3 rounded-3 d-flex align-items-center bg-body-secondary border-start border-4 border-danger'
                style='cursor: pointer;'
                onClick={this.openArticle}
            >
                <div class='flex-fill'>
                    <div class='fw-bold mb-1 text-danger' style='font-size: 0.85em; text-transform: uppercase; letter-spacing: 0.05em;'>
                        Les også
                    </div>
                    <span
                        class='fw-bold text-body'
                        style='font-size: 1.05em; line-height: 1.3;'
                    >
                        {article.title}
                    </span>
                </div>
                {thumbnail && (
                    <div class='ms-3 flex-shrink-0'>
                        <img
                            src={thumbnail}
                            alt={article.title || ''}
                            class='rounded'
                            style='width: 80px; height: 80px; object-fit: cover;'
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default ReadAlsoBox;
